import { render } from "./BovineByFarmLotChart.vue?vue&type=template&id=3460f5c2&scoped=true"
import script from "./BovineByFarmLotChart.vue?vue&type=script&lang=js"
export * from "./BovineByFarmLotChart.vue?vue&type=script&lang=js"

import "./BovineByFarmLotChart.vue?vue&type=style&index=0&id=3460f5c2&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3460f5c2"]])

export default __exports__